module.exports = {"id":"177953","name":"Clément Chantôme","rating":"72","photo":"./data/images/photos/4/177953.png","club":{"name":"RC Lens","logo":"./data/images/clubs/RCLens.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClementChantome0.json
// module id = 837
// module chunks = 0